import React from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showUrgency?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showUrgency = true,
  showPurchaseNotifications = true
}: AppProps) {
  useMetaPixel();
  return <div className="w-full bg-white" data-id="element-0" data-mp="23t8i6gzjcnei">
      <main data-id="element-1" data-mp="3ikh7o8icgqyg">
        <Hero data-id="element-2" data-mp="3ikqytzf4l45q" />
        <ProofBar data-id="element-3" data-mp="3ij66mgga9xb1" />
        <Problem data-id="element-4" data-mp="3ijpcuzwkmx98" />
        <Solution data-id="element-5" data-mp="3ii4r9zs8ioni" />
        <WhatYouGet data-id="element-6" data-mp="3mlax56bfqdtg" />
        <Bonuses data-id="element-7" data-mp="3mkrgru1fnxhj" />
        <Pricing showUrgency={showUrgency} data-id="element-8" data-mp="3mk83wrqn3zad" />
        <Testimonials data-id="element-9" data-mp="3rc9dg5wfbbwp" />
        <Guarantee data-id="element-10" data-mp="3rbzn2h7gv2qh" />
        <Faq data-id="element-11" data-mp="3rdkisa5iorpx" />
        <CostOfInaction data-id="element-12" data-mp="3rcsulke91w9o" />
        <FinalCta showUrgency={showUrgency} data-id="element-13" data-mp="3relv0hy9rk98" />
      </main>
      <Footer data-id="element-14" data-mp="4n5w26l2pak" />
      {showPurchaseNotifications && <PurchaseToast data-id="element-15" data-mp="2zl3a7gleoy37" />}
    </div>;
}